
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft, Search, Users, Filter } from "lucide-react";
import RestaurantSelector from "@/components/analytics/RestaurantSelector";
import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";

interface CustomersHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedRestaurants: string[];
  handleRestaurantChange: (restaurantIds: string[]) => void;
  userRestaurants?: any[];
  toggleFilters: () => void;
  showFilters: boolean;
  activeFilterCount: number;
}

export const CustomersHeader = ({ 
  searchQuery, 
  setSearchQuery, 
  selectedRestaurants, 
  handleRestaurantChange,
  userRestaurants,
  toggleFilters,
  showFilters,
  activeFilterCount
}: CustomersHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
      <div className="flex items-center">
        <Button 
          variant="ghost" 
          className="mr-2"
          onClick={() => navigate('/dashboard')}
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back
        </Button>
        <div>
          <h1 className="text-2xl font-bold flex items-center">
            <Users className="mr-2 h-6 w-6" />
            Customers
          </h1>
          <p className="text-muted-foreground">
            Manage and view customer profiles and loyalty status
          </p>
        </div>
      </div>
      
      <div className="w-full md:w-auto flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1 sm:min-w-[260px]">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search customers..."
            className="pl-9"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        
        {userRestaurants && userRestaurants.length > 0 && (
          <RestaurantSelector
            restaurants={userRestaurants}
            selectedRestaurants={selectedRestaurants}
            onRestaurantChange={handleRestaurantChange}
            displayType="dropdown"
            label=""
            className="min-w-48"
          />
        )}
        
        <Button 
          variant={showFilters ? "secondary" : "outline"} 
          onClick={toggleFilters}
          className="ml-auto sm:ml-0"
        >
          <Filter className="h-4 w-4 mr-2" />
          Filters
          {activeFilterCount > 0 && (
            <Badge variant="secondary" className="ml-1 h-5 w-5 rounded-full p-0 flex items-center justify-center bg-primary text-primary-foreground">
              {activeFilterCount}
            </Badge>
          )}
        </Button>
      </div>
    </div>
  );
};
